export default {
  'goldkid-conditions:title': 'Шарттар',
  'goldkid-conditions-table-row-1:key': 'Баланың жасы',
  'goldkid-conditions-table-row-1:value': '6 жастан 16 жасқа дейін',
  'goldkid-conditions-table-row-2:key': 'Жылдық <br>қызмет көрсету',
  'goldkid-conditions-table-row-2:value': '0&nbsp;₸',
  'goldkid-conditions-table-row-3:key': 'Ата-ананың <br> Kaspi Gold <br> картасынан толықтыру',
  'goldkid-conditions-table-row-3:value': 'күніне 1 млн&nbsp;₸ дейін',
  'goldkid-conditions-table-row-4:key': 'Өзге клиенттердің Kaspi Gold <br> картасынан толықтыру',
  'goldkid-conditions-table-row-4:value': 'айына 100 000&nbsp;₸ дейін',
  'goldkid-conditions-table-row-5:key': 'Өзге клиенттердің Kaspi Gold<br>  картасына ақша аудару',
  'goldkid-conditions-table-row-5:value': 'айына 100 000&nbsp;₸ дейін',
  'goldkid-conditions-table-row-6:key': 'Қолма-қол ақша алу',
  'goldkid-conditions-table-row-6:value': 'айына 10 000&nbsp;₸ дейін',
  'goldkid-conditions-table-row-7:key': 'Қолдана алатын операциялар',
  'goldkid-conditions-table-row-7:value': 'Сатып алған затының ақысын төлеу, ақша аудару, төлемдер (телефон, іс-шара билеттері, ойындар, жалға велосипед алу, көлік картасын толықтыру)',
  'goldkid-conditions-table-row-8:key': 'Қолдана <br> алмайтын операциялар',
  'goldkid-conditions-table-row-8:value': 'Кредит ресімдеу,<br> Kaspi Депозит аштыру, Kaspi.kz-тегі Магазинде зат сатып алу, өзге банктердің картасына ақша аудару'
}
